import { regexEmail } from 'utils/utils'

export const LOGIN_VALIDATION = {
    email: {
        required: 'Email wajib diisi',
        format: {
            pattern: regexEmail,
            message: 'Format email tidak sesuai',
        },
    },
    password: {
        required: 'Password wajib diisi',
        minimum: {
            value: 8,
            message: 'Password minimal 8 karakter',
        },
    },
    recaptcha_token: { required: 'Invalid Captcha' },
}
